import { Outlet } from "react-router";

import { PositionErrorModalProvider } from "~contexts/PositionContext/PositionErrorModalContext";

export function TimeTrackingOutlet() {
  return (
    <PositionErrorModalProvider>
      <Outlet />
    </PositionErrorModalProvider>
  );
}
